import * as React from 'react';

const SvgFormText = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M13.25 7.5H19V5H5v2.5h5.75V19h2.5V7.5Z", clipRule: "evenodd" })
);

export { SvgFormText as default };
//# sourceMappingURL=FormText.es.js.map
